/**
 * TOSS Web Application - Messenger Hub Manager (Singleton)
 *
 * Shared SignalR manager instance for the messenger hub.
 * Both useMessengerSignalR and useTypingIndicator must import from here
 * to avoid creating two separate SignalR connections.
 */

import { SignalRManager } from '@/realtime/signalr';
import { SIGNALR_HUBS } from '@/types';

let messengerHubManager: SignalRManager | null = null;

export function getMessengerHub(): SignalRManager {
  if (!messengerHubManager) {
    messengerHubManager = new SignalRManager({ url: SIGNALR_HUBS.MESSENGER, autoReconnect: true });
  }
  return messengerHubManager;
}
